import createCRUDObservable from 'redux-observable-crud'
import { combineEpics } from 'redux-observable'
import { AllCentersRedux } from '../Redux/AllCentersRedux'

const allCentersCrudObservable = createCRUDObservable({
  mainRedux: AllCentersRedux,
  reduxPath: 'allCenters',
})

export const allCentersObservers = Object.assign({}, allCentersCrudObservable.observers, {})

export const allCentersEpic = combineEpics(
  allCentersCrudObservable.epic,
)



// WEBPACK FOOTER //
// ./src/Data/Observables/AllCentersObservable.js